import React, {useEffect, useRef} from "react";
import {
    MediaPermissionsError,
    MediaPermissionsErrorType,
    requestMediaPermissions,
} from "mic-check";
import MediaOnboardingDialog from "./mediaOnboardingDialog";

enum DialogType {
    explanation = "explanation",
    systemDenied = "systemDenied",
    userDenied = "userDenied",
    trackError = "trackError",
}

const PermissionCheck = () => {
    const [audioAllowed, setAudioAllowed] = React.useState<boolean>(false);
    const [videoAllowed, setVideoAllowed] = React.useState<boolean>(false);
    const [showDialog, setShowDialog] = React.useState<DialogType | null>(null);
    const [errorDetails, setErrorDetails] = React.useState<
        MediaPermissionsError | undefined
    >();

    const showDialogRef = useRef(showDialog);

    showDialogRef.current = showDialog;
    const audioAllowedRef = useRef(false);
    audioAllowedRef.current = audioAllowed;
    const videoAllowedRef = useRef(false);
    videoAllowedRef.current = videoAllowed;

    useEffect(() => {
        checkPermissions(); // eslint-disable-next-line
    }, []);

    const checkForExplanationDialog = () => {
        if (
            (!audioAllowedRef.current || !videoAllowedRef.current) &&
            showDialogRef.current === null
        )
            setShowDialog(DialogType.explanation);
    };

    const checkMediaPermissions = async () => {
        let allowed = true;
        try {
            await requestMediaPermissions();
            setAudioAllowed(true);
            setVideoAllowed(true);
            setShowDialog(null);
        } catch (error: any) {
            if (error.type === MediaPermissionsErrorType.SystemPermissionDenied) {
                // user denied permission
                setShowDialog(DialogType.systemDenied);
            } else if (
                error.type === MediaPermissionsErrorType.UserPermissionDenied
            ) {
                // browser doesn't have access to devices
                setShowDialog(DialogType.userDenied);
            } else if (
                error.type === MediaPermissionsErrorType.CouldNotStartVideoSource
            ) {
                // most likely when other apps or tabs are using the cam/mic (mostly windows)
                setShowDialog(DialogType.trackError);
            } else {
                console.warn("error")
            }
            setErrorDetails(error);
            allowed = false;
        } finally {
            setTimeout(() => {
                checkForExplanationDialog();
            }, 500);
        }
        return allowed;
    };

    const checkPermissions = async () => {
        const checkCameraPermission = await navigator.permissions.query({
            name: "camera" as PermissionName,
        });
        const checkMicrophonePermission = await navigator.permissions.query({
            name: "microphone" as PermissionName,
        });
        if (
            (checkCameraPermission.state === "prompt" &&
                checkMicrophonePermission.state === "prompt") ||
            checkCameraPermission.state === "denied" ||
            checkMicrophonePermission.state === "denied"
        ) {
            checkMediaPermissions();
        }
    };

    return (
            <MediaOnboardingDialog
                showDialog={showDialog}
                retry={() => checkPermissions()}
                errorDetails={errorDetails}
            />
    );
};

export default PermissionCheck;
